import { createBrowserRouter, Navigate } from 'react-router-dom';

import { LayoutAdvertiser } from 'app/layouts/LayoutAdvertiser/LayoutAdvertiser';
import { routerPublic } from 'app/router/RouterPublic';
import {
	Contractors,
	CreateOffer,
	Dashboard,
	Documents,
	EditOffer,
	LegalInfo,
	Offer,
	Offers,
	Reports,
	Task,
	Wallet,
} from 'pages/advertiser';
import { NotFound } from 'pages/NotFound';
import { EMainRoutes } from 'shared/typings';

export const routerAdvertiser = [
	{
		path: `/${EMainRoutes.ADVERTISER}`,
		element: <LayoutAdvertiser />,
		errorElement: <LayoutAdvertiser outlet={<NotFound />} />,
		children: [
			{
				path: '',
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.DASHBOARD,
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.CONTRACTORS,
				element: <Contractors />,
			},
			{
				path: EMainRoutes.DOCUMENTS,
				element: <Documents />,
			},
			{
				path: EMainRoutes.LEGAL_INFO,
				element: <LegalInfo />,
			},
			{
				path: EMainRoutes.REPORTS,
				element: <Reports />,
			},
			{
				path: `${EMainRoutes.TASK}/:slug`,
				element: <Task />,
			},
			{
				path: EMainRoutes.BALANCE,
				element: <Wallet />,
			},
			{
				path: EMainRoutes.OFFERS,
				element: <Offers />,
			},
			{
				path: EMainRoutes.OFFER,
				children: [
					{
						path: ':slug',
						element: <Offer />,
					},
					{
						path: EMainRoutes.CREATE,
						element: <CreateOffer />,
					},
					{
						path: `:slug/${EMainRoutes.EDIT}`,
						element: <EditOffer />,
					},
				],
			},
		],
	},
	{
		path: '*',
		element: (
			<Navigate
				replace
				to={{ pathname: `/${EMainRoutes.ADVERTISER}/`, search: window.location.search }}
			/>
		),
	},
];

export const routerAdvertiserApp = createBrowserRouter(
	[...routerAdvertiser, ...routerPublic,
		{
			path: '*',
			element: (
				<Navigate
					replace
					to={{ pathname: `/${EMainRoutes.ADVERTISER}/`, search: window.location.search }}
				/>
			)
		}
	]
);
